// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'what-input';
import 'whatwg-fetch';

import Vue from 'vue';
import VueAnalytics from 'vue-analytics';
// import WebFont from 'webfontloader';
import svg4everybody from 'svg4everybody';
import objectFitImages from 'object-fit-images';
import objectFitVideos from 'object-fit-videos';
import VueResource from 'vue-resource';

import './custom-polyfills';
import App from './App';
import store from './store';

import router from './router';

Vue.use(VueResource);

Vue.use(VueAnalytics, {
  id: ['UA-28461930-1', 'UA-72599322-1'],
  autoTracking: {
    screenview: true,
  },
  debug: {
    sendHitTask: process.env.NODE_ENV === 'production',
  },
});

Vue.mixin({
  data() {
    return {
      get baseUrl() {
        return process.env.NODE_ENV === 'production' ? '' : 'http://localhost:8080/static/';
      },
    };
  },
});

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App },
  mounted() {
    svg4everybody();
    objectFitImages();
    objectFitVideos();
    // WebFont.load({
    //   google: {
    //     families: ['Montserrat:300,400'],
    //   },
    //   custom: {
    //     families: ['Jasmine'],
    //   },
    // });
  },
});



// WEBPACK FOOTER //
// ./src/main.js